import { jsx as _jsx } from "react/jsx-runtime";
import { alpha } from '@mui/material';
import MuiBottomNavigationAction from '@mui/material/BottomNavigationAction';
import * as React from 'react';
import { FlexBox } from '../box';
import { useHover, useMergeRefs } from '../hooks';
import { getIcon } from '../icon';
import { usePaletteColor } from '../theme';
export const BottomNavigationAction = React.forwardRef((props, outerRef) => {
    const { icon, iconProps, state, dragOver, width, ...muiProps } = props;
    const innerRef = useMergeRefs(outerRef);
    const iconColor = usePaletteColor(state ? 'primary.main' : 'components.top-navigation.icon');
    const labelColor = usePaletteColor(state ? 'primary.main' : 'components.top-navigation.font');
    const Icon = icon ? getIcon(icon) : undefined;
    const activeColor = usePaletteColor('primary._states.selected');
    const hoverColor = usePaletteColor('action.hover');
    const dragOverColor = alpha(iconColor, 0.2);
    const { hovered } = useHover(innerRef);
    const IconWrapper = () => {
        return (_jsx(FlexBox, { className: "BottomNavigationAction-iconWrapper", padding: [0.75, 1], marginBottom: 0.25, borderRadius: 1, visibility: state === 'edit.empty' ? 'hidden' : undefined, sx: {
                background: () => {
                    if (hovered && !state) {
                        return hoverColor;
                    }
                    return state === 'active' ? activeColor : undefined;
                },
                pointerEvents: 'none'
            }, children: Icon && (_jsx(Icon, { color: () => iconColor, ...iconProps, sx: { fontSize: 24, ...iconProps?.sx } })) }));
    };
    return (_jsx(MuiBottomNavigationAction, { ref: innerRef, showLabel: true, "data-role": "bottom-navigation-action", ...muiProps, icon: _jsx(IconWrapper, {}), sx: {
            '&.MuiBottomNavigationAction-root': {
                userSelect: 'none',
                pl: 0.5,
                pr: 0.5,
                width,
                minWidth: 0,
                borderRadius: 1,
                borderStyle: 'dashed',
                borderWidth: 1,
                borderColor: () => {
                    return state === 'edit' || state === 'edit.empty'
                        ? labelColor
                        : 'transparent';
                },
                backgroundColor: () => {
                    if (dragOver) {
                        return dragOverColor;
                    }
                    return state === 'edit' ? activeColor : undefined;
                }
            },
            '.MuiBottomNavigationAction-label': {
                whiteSpace: 'nowrap',
                fontSize: (theme) => theme.typography.caption.fontSize,
                color: labelColor,
                visibility: state === 'edit.empty' ? 'hidden' : undefined,
                ...(width
                    ? {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: 'calc(100% - 5px)'
                    }
                    : {})
            },
            ...muiProps.sx
        } }));
});
